
import OneTrustLink from "./OneTrustLink";
import useOneTrust from '../../hooks/useOneTrust';
import { createGlobalStyle } from 'styled-components';

const BLUE = '#3550a1';

const CleengFooterStyle = createGlobalStyle`
  
   .checkout-footer {
    font-size: 14px;
    min-width: 135px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    flex-direction: column;
    border-top: 1px solid rgb(211, 219, 230);
   }
   .checkout-footer a {
    text-align: center;
   }
`;

export default function CleengFooter() {
    const isEnabled = useOneTrust();
    
    return (
        <>
            <CleengFooterStyle/>
            {isEnabled && <section className="checkout-footer py-3">
                <p style={{ textAlign: 'center', marginBottom: '0px' }}>
                    <OneTrustLink color={BLUE} />
                </p>
                <div className="text-center mb-2"><p className="fw-light rights-reserved">&copy; {new Date().getFullYear()}  Newsmax Media, LLC. All rights reserved. Newsmax+ & Newsmax2 are property of Newsmax Media.</p></div>
            </section>}
        </>
    )
}